import { render, staticRenderFns } from "./videomodal.vue?vue&type=template&id=9d716dd8&"
import script from "./videomodal.vue?vue&type=script&lang=js&"
export * from "./videomodal.vue?vue&type=script&lang=js&"
import style0 from "./videomodal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports